import {
  Flex,
  SearchField,
  Text,
  Tooltip,
  TooltipTrigger,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Item,
  ButtonGroup,
  useAsyncList,
  View,
  MenuTrigger,
  ActionButton,
  Menu,
  DialogContainer,
  Link as V3Link,
  FileTrigger,
  ContextualHelpTrigger,
  Dialog,
  Heading,
  Content,
  ToggleButton,
} from "@adobe/react-spectrum";
import TreeExpandAll from "@spectrum-icons/workflow/TreeExpandAll";
import TreeCollapseAll from "@spectrum-icons/workflow/TreeCollapseAll";
import Add from "@spectrum-icons/workflow/Add";
import Remove from "@spectrum-icons/workflow/Remove";
import ChevronRight from "@spectrum-icons/workflow/ChevronRight";
import ChevronDown from "@spectrum-icons/workflow/ChevronDown";
import Edit from "@spectrum-icons/workflow/Edit";
import Gears from "@spectrum-icons/workflow/Gears";
import Dolly from "@spectrum-icons/workflow/Dolly";
import Alias from "@spectrum-icons/workflow/Alias";
import Delete from "@spectrum-icons/workflow/Delete";
import History from "@spectrum-icons/workflow/History";
import Download from "@spectrum-icons/workflow/Download";
import UploadToCloudOutline from "@spectrum-icons/workflow/UploadToCloudOutline";
import Undo from "@spectrum-icons/workflow/Undo";
import Checkmark from "@spectrum-icons/workflow/Checkmark";
import Close from "@spectrum-icons/workflow/Close";
import Pending from "@spectrum-icons/workflow/Pending";
import Refresh from "@spectrum-icons/workflow/Refresh";
import { useOktaAuth } from "@okta/okta-react";
import React, { useState, useEffect, useRef } from "react";
import {
  error as ErrorToast,
  success as SuccessToast,
} from "@react/react-spectrum/Toast";
import { gtmhApi } from "../../../api/gtmhApi";
import { bulkChangesApi } from "../../../api/bulkChangesApi";
import LoadingDialog from "../../../components/Dialog/LoadingDialog";
import CreateParentSubDialog from "../../../components/Dialog/HMS/GTMH/CreateParentSubDialog";
import DownloadParentSubsDialog from "../../../components/Dialog/HMS/GTMH/DownloadParentSubsDialog";
import PromoteSubDialog from "../../../components/Dialog/HMS/GTMH/PromoteSubDialog";
import EditSubDialog from "../../../components/Dialog/HMS/GTMH/EditSubDialog";
import DemoteParentDialog from "../../../components/Dialog/HMS/GTMH/DemoteParentDialog";
import ApproveSubDialog from "../../../components/Dialog/HMS/GTMH/ApproveSubDialog";
import RejectSubDialog from "../../../components/Dialog/HMS/GTMH/RejectSubDialog";
import ApproveRejectedSubDialog from "../../../components/Dialog/HMS/GTMH/ApproveRejectedSubDialog";
import RevertPendingDeleteSubDialog from "../../../components/Dialog/HMS/GTMH/RevertPendingDeleteSubDialog";
import SubHistoryDialog from "../../../components/Dialog/HMS/GTMH/SubHistoryDialog";
import DeleteAccountDialog from "../../../components/Dialog/HMS/GTMH/DeleteAccountDialog";
import Table from "../../../components/Common/Table";
import {
  ParentSubColumns,
  ParentSubInReviewColumns,
} from "../../../constants/Columns";
import { GTMHInfoColumns } from "../../../constants/SlidingPaneLabels";
import CamSlidingPane from "../../../components/Common/CamSlidingPane/CamSlidingPane";
import ViewEnrichedAttributesForm from "../../../components/Forms/SearchForm/ViewEnrichedAttributesForm";
import { ADMIN, OPERATOR, SUPERUSER, USER } from "../../../constants/RoleType";
import { GTMH } from "../../../constants/CamFunctions";
import useValidUserAccess from "../../../hooks/useValidUserAccess";
import useUserProfile from "../../../context/user-context";

export default function ParentSubManagement() {
  const [isPageLoading, setPageLoading] = useState(false);
  const [searchString, setSearchString] = useState(
    "Search by name, domain, hq duns"
  );
  const [isIdSearch, setIsIdSearch] = useState(false);
  const [isNameSearch, setIsNameSearch] = useState(false);

  const [areRowsExpanded, setAreRowsExpanded] = useState(true);

  const [currentStatus, setCurrentStatus] = useState("active");

  const [filterIdList, setFilterIdList] = useState([]); // list to keep track of all ids which are individually expanded/collapsed aka opposite behavior from areRowsExpanded
  const [filterSelectedIdList, setFilterSelectedIdList] = useState([]); // list to keep track of all ids where selected is expanded so all subs should show

  const searchResultSize = 1000;
  const [fetchParentSubsRequest, setParentSubsRequest] = useState({
    search_string: "",
    sub_name: "",
    sub_id: "",
    domain: "",
    duns_number: "",
    status: [currentStatus],
    page_no: 1,
    page_size: searchResultSize,
    sort_options: [{ field_name: "parent_id", sort_order: 1 }],
  });
  const [pageNo, setPageNo] = useState(0);
  const prevRequestRef = useRef();
  const isFirstRender = useRef(true);
  const [searchCounts, setSearchCounts] = useState({
    active: "",
    "in-review": "",
    rejected: "",
    deleted: "",
  });
  const [selectedRow, setSelectedRow] = useState({});
  const [createNewAccount, setCreateNewAccount] = useState(false);
  const [viewAccountHistory, setViewAccountHistory] = useState(false);
  const [editAccount, setEditAccount] = useState(false);
  const [promoteSub, setPromoteSub] = useState(false);
  const [demoteParent, setDemoteParent] = useState(false);
  const [approveSub, setApproveSub] = useState(false);
  const [rejectSub, setRejectSub] = useState(false);
  const [approveRejectedSub, setApproveRejectedSub] = useState(false);
  const [revertPendingDeletionSub, setRevertPendingDeletionSub] =
    useState(false);
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [downloadData, setDownloadData] = useState(false);
  const [isRefreshTable, setRefreshTable] = useState(false);

  const [isSidePaneOpen, setIsSidePaneOpen] = useState(false);
  const [sidePaneData, setSidePaneData] = useState([]);
  // const [isPageLoading, setIsPageLoading] = useState(false);
  const [isSearchLoading, setSearchLoading] = useState("");

  const parentSubColumns = ParentSubColumns();
  const parentSubInReviewColumns = ParentSubInReviewColumns();
  const parentSubDeletedColumns = ParentSubInReviewColumns().filter(
    (x) => x.uid !== "num_subs"
  );
  const parentSubRejectedColumns = ParentSubInReviewColumns().filter(
    (x) => !["num_subs", "status"].includes(x.uid)
  );

  const { authState } = useOktaAuth();

  const isGTMHActionAllowed = useValidUserAccess(
    [ADMIN, SUPERUSER, OPERATOR, USER],
    GTMH
  );
  const isAdminActionAllowed = useValidUserAccess([ADMIN], GTMH);
  const { user } = useUserProfile();

  const tabs = [
    { id: "active", name: "Active" },
    { id: "in-review", name: "In Review" },
    { id: "rejected", name: "Rejected" },
    { id: "deleted", name: "Deleted" },
  ];

  // removes duplicate items from list in table
  const removeDuplicates = (origList) =>
    Array.from(new Map(origList.map((item) => [item.id, item])).values());

  const handleExpandRows = () => {
    setAreRowsExpanded(!areRowsExpanded);
  };

  const handleSelectionChange = (tabSelection) => {
    const status =
      tabSelection === "deleted"
        ? ["deleted", "pending-deletion"]
        : [tabSelection];
    setFilterIdList([]);
    setFilterSelectedIdList([]);
    setCurrentStatus(tabSelection);
    setParentSubsRequest({
      ...fetchParentSubsRequest,
      status,
      page_no: 1,
    });
    setPageNo(0);
  };

  // expand parent/sub data into one list
  const expandParentSubs = (data, expandList) => {
    if (expandList.length === 0) {
      return data.flatMap((item) => {
        const parent = { ...item, expanded: areRowsExpanded };
        // delete parent.subs;

        const children = (item.subs || [])
          // .filter((subs) => !filterIdList.includes(subs.sub_id))
          .map(({ subs, ...child }) => ({
            ...child,
            parent_id: item.sub_id,
            parent_name: item.parent_name,
            parent_sub: item.sub_id === child.sub_id, // true if the sub is also the parent aka the ids match
            expanded: areRowsExpanded,
            parent_status: item.status,
          }));
        return [parent, ...children];
      });
    }
    return data.flatMap((item) => {
      const parent = { ...item, expanded: areRowsExpanded };
      delete parent.subs;
      let children = [];
      if (
        (filterIdList.length === 0 || filterIdList.includes(item.sub_id)) &&
        item.parent
      ) {
        children = item.subs.map(({ subs, ...child }) => ({
          ...child,
          parent_id: item.sub_id,
          parent_name: item.parent_name,
          parent_sub: item.sub_id === child.sub_id, // true if the sub is also the parent aka the ids match
          expanded: areRowsExpanded,
          parent_status: item.status,
        }));
      }
      return [parent, ...children];
    });
  };

  const list = useAsyncList({
    initialFilterText: "",
    async load({ filterText, cursor }) {
      let json = {
        results: [],
      };
      const request = cursor || fetchParentSubsRequest;

      if (filterText !== "") {
        setSearchLoading("loading");
        if (pageNo === 0) setPageLoading(true);
        json = await gtmhApi.fetchParentSubs(request, authState.accessToken);
      }
      let results;
      // set count for each status tab only when tab is switched/page size is 1
      const resultCounts = json?.results?.status_counts;
      if (resultCounts !== undefined && json?.results.current_page === 1)
        setSearchCounts(resultCounts);

      // set results list
      if (!json?.results?.results) results = [];
      else if (["deleted", "rejected"].includes(currentStatus))
        results = expandParentSubs(json.results.results, []).filter(
          (x) => !x.parent
        );
      else if (!areRowsExpanded) results = json.results.results;
      else {
        results = expandParentSubs(json.results.results, []);
      }

      setSearchLoading("");
      setPageLoading(false);
      setPageNo(json?.results.current_page);
      // setPageNo(json?.results.current_page + 1);
      return {
        items: results,
        cursor:
          results.length < searchResultSize
            ? null
            : {
                ...fetchParentSubsRequest,
                page_no: json?.results.current_page + 1,
              },
      };
    },
    getKey: (item) => item?.id,
  });

  const renderActionButton = (rowInfo) => (
    <MenuTrigger direction="right">
      <ActionButton isQuiet>
        <Gears />
      </ActionButton>
      {currentStatus === "active" && (
        <Menu
          onAction={(key) => {
            setSelectedRow(rowInfo);
            if (key === "edit") setEditAccount(true);
            if (key === "promote") setPromoteSub(true);
            if (key === "demote") setDemoteParent(true);
            if (key === "history") setViewAccountHistory(true);
            if (key === "delete") setDeleteAccount(true);
          }}
        >
          <Item key="history">
            <History />
            <Text>History</Text>
          </Item>
          {isAdminActionAllowed && (
            <Item key="edit">
              <Edit />
              <Text>Edit</Text>
            </Item>
          )}
          {isAdminActionAllowed && !rowInfo.parent && !rowInfo.parent_sub && (
            <Item key="promote">
              <Alias />
              <Text>Promote</Text>
            </Item>
          )}
          {isAdminActionAllowed && rowInfo.parent && rowInfo.num_subs <= 1 && (
            <Item key="demote">
              <Dolly />
              <Text>Demote</Text>
            </Item>
          )}
          {isAdminActionAllowed &&
            ((rowInfo.parent && rowInfo.num_subs <= 1) ||
              (!rowInfo.parent && rowInfo.parent_id !== rowInfo.sub_id)) && (
              <Item key="delete">
                <Delete />
                <Text>Delete</Text>
              </Item>
            )}
          {/* info to show that sub cannot be deleted until all subs underneath the parent beside this one are deleted */}
          {isAdminActionAllowed &&
            !rowInfo.parent &&
            rowInfo.parent_id === rowInfo.sub_id && (
              <ContextualHelpTrigger isUnavailable>
                <Item key="delete">
                  <Delete />
                  <Text>Delete</Text>
                </Item>
                <Dialog>
                  <Heading>Delete Sub</Heading>
                  <Content>
                    This sub cannot be deleted as it is the same as the parent.
                    Please delete the parent instead.
                  </Content>
                </Dialog>
              </ContextualHelpTrigger>
            )}
        </Menu>
      )}
      {currentStatus === "in-review" && (
        <Menu
          onAction={(key) => {
            setSelectedRow(rowInfo);
            if (key === "edit") setEditAccount(true);
            if (key === "promote") setPromoteSub(true);
            if (key === "demote") setDemoteParent(true);
            if (key === "approve") setApproveSub(true);
            if (key === "reject") setRejectSub(true);
            if (key === "history") setViewAccountHistory(true);
            if (key === "delete") setDeleteAccount(true);
          }}
        >
          <Item key="history">
            <History />
            <Text>History</Text>
          </Item>
          {((rowInfo.parent && rowInfo.status === "in-review") ||
            (!rowInfo?.parent &&
              rowInfo?.parent_status === "active" &&
              rowInfo.status === "in-review")) &&
            isAdminActionAllowed && (
              <Item key="approve">
                <Checkmark />
                <Text>Approve</Text>
              </Item>
            )}
          {/* info to show that if parent is not approved yet cannot approve subs */}
          {!rowInfo?.parent &&
            rowInfo?.parent_status === "in-review" &&
            rowInfo.status === "in-review" &&
            isAdminActionAllowed && (
              <ContextualHelpTrigger isUnavailable>
                <Item key="approve">
                  <Checkmark />
                  <Text>Approve</Text>
                </Item>
                <Dialog>
                  <Heading>Approve Sub</Heading>
                  <Content>
                    Parent must be approved before sub can be approved.
                  </Content>
                </Dialog>
              </ContextualHelpTrigger>
            )}
          {((rowInfo.parent && rowInfo.status === "in-review") ||
            (!rowInfo?.parent &&
              rowInfo?.parent_status === "active" &&
              rowInfo.status === "in-review")) &&
            isAdminActionAllowed && (
              <Item key="reject">
                <Close />
                <Text>Reject</Text>
              </Item>
            )}
          {rowInfo.status === "in-review" && isGTMHActionAllowed && (
            <Item key="edit">
              <Edit />
              <Text>Edit</Text>
            </Item>
          )}
          {!rowInfo.parent && !rowInfo.parent_sub && isGTMHActionAllowed && (
            <Item key="promote">
              <Alias />
              <Text>Promote</Text>
            </Item>
          )}
          {rowInfo.status === "in-review" &&
            rowInfo.parent &&
            rowInfo.num_subs <= 1 &&
            isGTMHActionAllowed && (
              <Item key="demote">
                <Dolly />
                <Text>Demote</Text>
              </Item>
            )}
          {rowInfo.status === "in-review" &&
            isGTMHActionAllowed &&
            ((rowInfo.parent &&
              rowInfo.subs.filter((x) => x.status === "in-review").length ===
                1) ||
              (!rowInfo.parent && rowInfo.parent_id !== rowInfo.sub_id)) && (
              <Item key="delete">
                <Delete />
                <Text>Delete</Text>
              </Item>
            )}
          {/* info to show that sub cannot be deleted until all subs underneath the parent beside this one are deleted */}
          {rowInfo.status === "in-review" &&
            isGTMHActionAllowed &&
            !rowInfo.parent &&
            rowInfo.parent_id === rowInfo.sub_id && (
              <ContextualHelpTrigger isUnavailable>
                <Item key="delete">
                  <Delete />
                  <Text>Delete</Text>
                </Item>
                <Dialog>
                  <Heading>Delete Sub</Heading>
                  <Content>
                    This sub cannot be deleted as it is the same as the parent.
                    Please delete the parent instead.
                  </Content>
                </Dialog>
              </ContextualHelpTrigger>
            )}
        </Menu>
      )}
      {currentStatus === "rejected" && (
        <Menu
          onAction={(key) => {
            setSelectedRow(rowInfo);
            if (key === "history") setViewAccountHistory(true);
            if (key === "approve_rejected") setApproveRejectedSub(true);
          }}
        >
          <Item key="history">
            <History />
            <Text>History</Text>
          </Item>
          {isAdminActionAllowed && (
            <Item key="approve_rejected">
              <Checkmark />
              <Text>Approve</Text>
            </Item>
          )}
        </Menu>
      )}
      {currentStatus === "deleted" && (
        <Menu
          onAction={(key) => {
            setSelectedRow(rowInfo);
            if (key === "history") setViewAccountHistory(true);
            if (key === "restore" && rowInfo.status === "deleted")
              setApproveRejectedSub(true);
            if (key === "restore" && rowInfo.status === "pending-deletion")
              setRevertPendingDeletionSub(true);
          }}
        >
          <Item key="history">
            <History />
            <Text>History</Text>
          </Item>
          {isAdminActionAllowed && (
            <Item key="restore">
              <Undo />
              <Text>Restore</Text>
            </Item>
          )}
        </Menu>
      )}
    </MenuTrigger>
  );

  const handleExpandCollapseSubs = (row) => {
    // If the sub_id is already in the filterIdList, remove it else add it.
    setFilterIdList((prev) => {
      if (prev.includes(row.sub_id)) {
        // If it includes, filter out the sub_id
        return [...prev.filter((id) => id !== row.sub_id)];
      }
      return [...prev, row.sub_id];
    });
  };

  const handleExpandCollapseSelectedSubs = (row) => {
    // If the sub_id is already in the filterIdList, remove it else add it.
    setFilterSelectedIdList((prev) => {
      if (prev.includes(row.sub_id)) {
        // If it includes, filter out the sub_id
        return [...prev.filter((id) => id !== row.sub_id)];
      }
      return [...prev, row.sub_id];
    });
  };

  const renderChevron = (row) => {
    if (areRowsExpanded) {
      if (filterIdList.includes(row.sub_id)) {
        return <ChevronRight />;
      }
      return <ChevronDown />;
    }
    if (!areRowsExpanded) {
      if (filterIdList.includes(row.sub_id)) return <ChevronDown />;
      return <ChevronRight />;
    }
    return <ChevronDown />;
  };

  const renderExpandSelected = (row) => {
    if (filterSelectedIdList.includes(row.sub_id)) {
      return <Remove size="S" />;
    }
    return <Add size="S" />;
  };

  const filterTableRows = () => {
    let filteredRows = list.items.map((item) => ({
      ...item,
      _shouldRerender: filterIdList.includes(item.sub_id), // logic that determines expansion so table rerenders
    }));
    // show only selected sub when searching
    // if (fetchParentSubsRequest.search_string !== "") {
    // if (
    //   fetchParentSubsRequest.search_string !== "" ||
    //   fetchParentSubsRequest.sub_id !== "" ||
    //   fetchParentSubsRequest.sub_name !== ""
    // ) {
    //   filteredRows = filteredRows.filter(
    //     (x) =>
    //       x.parent ||
    //       (filterSelectedIdList.length > 0 &&
    //         filterSelectedIdList.includes(x.parent_id)) ||
    //       x.selected
    //   );
    // }
    filteredRows = filteredRows.filter(
      (x) =>
        x.parent ||
        (filterSelectedIdList.length > 0 &&
          filterSelectedIdList.includes(x.parent_id)) ||
        x.selected
    );
    // handle individual expand/collapse
    if (filterIdList.length > 0) {
      if (areRowsExpanded) {
        filteredRows = filteredRows.filter(
          (row) => !(filterIdList.includes(row.parent_id) && !row.parent)
        );
      }
      if (!areRowsExpanded) {
        filteredRows = expandParentSubs(filteredRows, filterIdList);
      }
    }
    return [...filteredRows];
  };

  const renderCell = (colKey, row) => {
    if (colKey === "id") {
      if (row.parent)
        return (
          <Flex direction="row" gap="size-100">
            <TooltipTrigger>
              <ActionButton
                isQuiet
                onPress={() => {
                  handleExpandCollapseSubs(row);
                  filterTableRows();
                }}
              >
                <View>{renderChevron(row)}</View>
              </ActionButton>
              <Tooltip>
                {row.expanded ? "View Subsidiaries" : "Hide Subsidiaries"}
              </Tooltip>
            </TooltipTrigger>
            <Flex alignItems="center">
              <Text>
                <V3Link
                  isQuiet
                  onPress={() => {
                    setSidePaneData(row);
                    setIsSidePaneOpen(!isSidePaneOpen);
                  }}
                >
                  {row[colKey]}
                </V3Link>
              </Text>
            </Flex>
          </Flex>
        );
      return (
        <Flex alignItems="center">
          <Text
            marginStart={
              ["deleted", "rejected"].includes(currentStatus) ? "0px" : "41px"
            }
          >
            <V3Link
              variant="secondary"
              isQuiet
              onPress={() => {
                setSidePaneData(row);
                setIsSidePaneOpen(!isSidePaneOpen);
              }}
            >
              {row[colKey]}
            </V3Link>
          </Text>
        </Flex>
      );
    }
    if (colKey === "status") {
      if (row.status === "in-review" || row.status === "pending-deletion")
        return (
          <TooltipTrigger>
            <ActionButton isQuiet>
              <View>
                <Pending color="notice" />
              </View>
            </ActionButton>
            <Tooltip>{row.status}</Tooltip>
          </TooltipTrigger>
        );
      return <></>;
    }
    if (colKey === "edit") return renderActionButton(row);
    if (colKey === "num_subs") {
      if (row.parent)
        return (
          <Flex>
            <span // eslint-disable-line jsx-a11y/no-static-element-interactions
              style={{
                cursor: "text",
                WebkitUserSelect: "text",
                fontWeight: row.parent ? "bold" : "normal",
                color: row.parent ? "#0057be" : "black",
                alignContent: "center",
              }}
              onPointerDown={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
            >
              <Text>{`${row.num_selected_subs}/${row.num_subs}`}</Text>
            </span>
            {/* {(fetchParentSubsRequest.search_string !== "" || fetchParentSubsRequest.search_string !== "") && */}
            {row.num_selected_subs !== row.num_subs && (
              <TooltipTrigger>
                <ActionButton
                  isQuiet
                  onPress={() => handleExpandCollapseSelectedSubs(row)}
                >
                  <View>{renderExpandSelected(row)}</View>
                </ActionButton>
                <Tooltip>View All/Selected Subs</Tooltip>
              </TooltipTrigger>
            )}
          </Flex>
        );
    }
    if (colKey === "modified_date_time")
      return (
        <span // eslint-disable-line jsx-a11y/no-static-element-interactions
          style={{
            cursor: "text",
            WebkitUserSelect: "text",
            fontWeight: row.parent ? "bold" : "normal",
            color: row.parent ? "#0057be" : "black",
          }}
          onPointerDown={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <Text>{row[colKey].split("T")[0]}</Text>
        </span>
      );
    return (
      <span // eslint-disable-line jsx-a11y/no-static-element-interactions
        style={{
          cursor: "text",
          WebkitUserSelect: "text",
          fontWeight: row.parent ? "bold" : "normal",
          color: row.parent ? "#0057be" : "black",
        }}
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <Text>{row[colKey]}</Text>
      </span>
    );
  };

  // handle when button is pressed to expand/collapse all rows - skip on first render
  // useEffect(() => {
  //   console.log("areRowsExpanded");
  //   setFilterIdList([]);
  //   setParentSubsRequest({
  //     ...fetchParentSubsRequest,
  //     page_no: 1,
  //   });
  //   setPageNo(1);
  //   list.setFilterText(fetchParentSubsRequest);
  // }, [areRowsExpanded]);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Skip on first render
    }

    setFilterIdList([]);
    setParentSubsRequest({
      ...fetchParentSubsRequest,
      page_no: 1,
    });
    setPageNo(0);
    list.setFilterText(fetchParentSubsRequest);
  }, [areRowsExpanded]);

  // useEffect(() => {
  //   list.setFilterText(fetchParentSubsRequest);
  // }, [fetchParentSubsRequest]);
  useEffect(() => {
    const prevSerialized = JSON.stringify(prevRequestRef.current);
    const newSerialized = JSON.stringify(fetchParentSubsRequest);

    if (isRefreshTable || prevSerialized !== newSerialized) {
      list.setFilterText(fetchParentSubsRequest);
      prevRequestRef.current = fetchParentSubsRequest;
    }
    setRefreshTable(false);
  }, [fetchParentSubsRequest]);

  useEffect(() => {
    if (isIdSearch) setSearchString("Search by ID");
    else setSearchString("Search by name, domain, hq duns");
  }, [isIdSearch]);

  useEffect(() => {
    if (isNameSearch) setSearchString("Search by name");
    else setSearchString("Search by name, domain, hq duns");
  }, [isNameSearch]);

  const refreshTable = () => {
    setRefreshTable(true);
    setPageNo(0);
    setParentSubsRequest({ ...fetchParentSubsRequest, page_no: 1 });
  };

  const renderTableCols = () => {
    if (currentStatus === "in-review") return parentSubInReviewColumns;
    if (currentStatus === "active") return parentSubColumns;
    if (currentStatus === "rejected") return parentSubRejectedColumns;
    return parentSubDeletedColumns;
  };

  const handleImport = (importFiles) => {
    setPageLoading(true);
    bulkChangesApi
      .importGTMHFiles(
        importFiles,
        "GTMH",
        "hierarchy-user (bulk)",
        user?.userId,
        user?.name,
        authState.accessToken
      )

      .then((fileImportStatusList) => {
        setPageLoading(false);
        Object.keys(fileImportStatusList).forEach((file) => {
          const fileStatus = fileImportStatusList[file];
          if (fileStatus.status) {
            SuccessToast(
              `Successfully imported ${file} (wf id: ${fileStatus?.wf_id})`,
              { timeout: 4000 }
            );
          } else {
            ErrorToast(
              `${file} import failed: ${fileStatus.message} (wf id: ${fileStatus?.wf_id})`,
              { timeout: 4000 }
            );
          }
        });
      })
      .catch((e) => {
        ErrorToast(
          e.response?.data?.message ||
            "Error importing file(s) please try again",
          { timeout: 2000 }
        );
        setPageLoading(false);
      });
  };

  return (
    <Flex direction="column" maxHeight="82vh" minHeight="82vh">
      <LoadingDialog isOpen={isPageLoading} />
      <Flex margin="size-300" gap="size-125" direction="row" width="90%">
        <Flex width="350px">
          <SearchField
            label={
              <Flex height="32px" alignItems="center">
                <Flex width="200px">
                  <Text UNSAFE_style={{ fontSize: "14px" }}>
                    Search Parents + Subs
                  </Text>
                </Flex>
                <Flex direction="column" alignItems="end" width="200px">
                  <Flex height="32px" alignItems="center" gap="5px">
                    <ToggleButton
                      isSelected={isNameSearch}
                      onChange={setIsNameSearch}
                      isDisabled={isIdSearch}
                      height="24px"
                    >
                      Name Search
                    </ToggleButton>
                    <ToggleButton
                      isSelected={isIdSearch}
                      onChange={setIsIdSearch}
                      isDisabled={isNameSearch}
                      height="24px"
                    >
                      ID Search
                    </ToggleButton>
                  </Flex>
                </Flex>
              </Flex>
            }
            placeholder={searchString}
            onSubmit={(val) => {
              setPageNo(0);
              if (isIdSearch) {
                setParentSubsRequest({
                  ...fetchParentSubsRequest,
                  page_no: 1,
                  search_string: "",
                  sub_name: "",
                  sub_id: val,
                });
              } else if (isNameSearch) {
                setParentSubsRequest({
                  ...fetchParentSubsRequest,
                  page_no: 1,
                  search_string: "",
                  sub_id: "",
                  sub_name: val,
                });
              } else {
                setParentSubsRequest({
                  ...fetchParentSubsRequest,
                  page_no: 1,
                  sub_id: "",
                  sub_name: "",
                  search_string: val,
                });
              }
            }}
            onClear={() => {
              setRefreshTable(true);
              setPageNo(0);
              setParentSubsRequest({
                ...fetchParentSubsRequest,
                search_string: "",
                sub_id: "",
                page_no: 1,
              });
            }}
            width="350px"
          />
        </Flex>
        <Flex marginStart="50px" alignItems="end" gap="size-125">
          {["active", "in-review"].includes(currentStatus) && (
            <TooltipTrigger>
              <Button variant="secondary" onPress={() => handleExpandRows()}>
                {areRowsExpanded ? <TreeCollapseAll /> : <TreeExpandAll />}
              </Button>
              <Tooltip>
                {areRowsExpanded ? "Collapse table rows" : "Expand table rows"}
              </Tooltip>
            </TooltipTrigger>
          )}
          <TooltipTrigger>
            <Button variant="secondary" onClick={() => setDownloadData(true)}>
              <Download />
            </Button>
            <Tooltip>Export parents + subs</Tooltip>
          </TooltipTrigger>
          {currentStatus === "active" && (
            <FileTrigger
              acceptedFileTypes={["text/csv"]}
              allowsMultiple
              onSelect={(e) => {
                const files = Array.from(e);
                handleImport(files);
              }}
            >
              <TooltipTrigger>
                <Button variant="secondary" isDisabled={!isAdminActionAllowed}>
                  <UploadToCloudOutline />
                </Button>
                <Tooltip>Import parents + subs</Tooltip>
              </TooltipTrigger>
            </FileTrigger>
          )}
          <TooltipTrigger>
            <Button variant="secondary" onClick={() => refreshTable()}>
              <Refresh />
            </Button>
            <Tooltip>Refresh</Tooltip>
          </TooltipTrigger>
        </Flex>
      </Flex>
      <Flex height="85%">
        <Tabs
          aria-label="Parent + Subsidiary Accounts"
          margin="size-300"
          marginTop="size-0"
          marginBottom="size-0"
          width="90%"
          direction="row"
          items={tabs}
          defaultSelectedKey="active"
          onSelectionChange={handleSelectionChange}
          minHeight={0}
        >
          <Flex>
            <TabList flex="1 1 auto">
              {(item) => (
                <Item>
                  {`${item.name} (${
                    item.id === "deleted"
                      ? (searchCounts.deleted ?? 0) +
                        (searchCounts["pending-deletion"] ?? 0)
                      : searchCounts[item.id] ?? 0
                  })`}
                </Item>
              )}
              {/* {(item) => <Item>{item.name}</Item>} */}
            </TabList>
            {((currentStatus === "in-review" && isGTMHActionAllowed) ||
              (currentStatus === "active" && isAdminActionAllowed)) && (
              <div
                style={{
                  display: "flex",
                  flex: "0 0 auto",
                  borderBottom:
                    "var(--spectrum-alias-border-size-thick) solid var(--spectrum-global-color-gray-300)",
                }}
              >
                <ButtonGroup>
                  <Button
                    variant="primary"
                    onClick={() => setCreateNewAccount(true)}
                  >
                    <Add />
                    <Text>{`Create ${
                      currentStatus === "in-review" ? "for Review" : ""
                    }`}</Text>
                  </Button>
                </ButtonGroup>
              </div>
            )}
          </Flex>
          <TabPanels minHeight={0}>
            {(item) => (
              <Item id={item.id}>
                <Flex
                  marginTop="size-50"
                  UNSAFE_style={{
                    backgroundColor: "white",
                    borderRadius: "0.5rem",
                  }}
                  direction="row"
                  // minHeight="95%"
                  // maxHeight="95%"
                  height="95%"
                >
                  {/* <TableView 
                    aria-label="parent sub table"
                    flex
                    marginTop="1rem"
                    // renderEmptyState={() => renderEmptyState()}
                    // overflowMode="wrap"
                    // selectionMode={selectionMode || "none"}
                    // onSelectionChange={onSelectionChange}
                    // selectedKeys={selectedKeys}
                    // density={density}
                    // disallowEmptySelection={disallowEmptySelection}
                    // disabledKeys={disabledKeys}
                    // onAction={onAction}
                    // dragAndDropHooks={allowDragAndDrop ? dragAndDropHooks : null}
                    // onSortChange={onSortChange}
                  >
                    <TableHeader columns={renderTableCols()}>
                      {(column) => (
                        <Column 
                          key={column.uid}
                          minWidth={column?.minWidth}
                          maxWidth={column?.maxWidth}
                          defaultWidth={column?.defaultWidth}
                          allowsResizing
                        >
                          {column.name}
                        </Column>
                      )}
                    </TableHeader>
                    <TableBody
                      items={removeDuplicates(filterTableRows())}
                      loadingState={
                        isSearchLoading !== ""
                          ? isSearchLoading
                          : list.loadingState
                      }
                      onLoadMore={list.loadMore}
                    >
                      {(item1) => (
                        <Row
                          key={
                            item1.id ||
                            item1.requestId ||
                            item1.camid ||
                            item1.relationship_id ||
                            item1.org_entity_id ||
                            item1.transaction_id
                          }
                        >
                          {(columnKey) => <Cell>{renderCell(columnKey, item1)}</Cell>}
                        </Row>
                      )}
                    </TableBody>
                  </TableView> */}
                  <Table
                    columns={renderTableCols()}
                    rows={removeDuplicates(filterTableRows())}
                    overflowMode="truncate"
                    loadingState={
                      isSearchLoading !== ""
                        ? isSearchLoading
                        : list.loadingState
                    }
                    onLoadMore={list.loadMore}
                    renderCell={renderCell}
                    selectionMode="none"
                    density="compact"
                    onSortChange={(val) => {
                      setPageNo(0);
                      setParentSubsRequest({
                        ...fetchParentSubsRequest,
                        page_no: 1,
                        sort_options: [
                          {
                            field_name: "modifieddatetime",
                            sort_order: val.direction === "ascending" ? 1 : -1,
                          },
                        ],
                      });
                    }}
                    sortCols={["modified_date_time"]}
                  />
                </Flex>
                <Flex justifyContent="end">
                  <Text>
                    {`${
                      (pageNo + 1) * searchResultSize <=
                      (searchCounts[currentStatus] ?? 0)
                        ? pageNo * searchResultSize
                        : searchCounts[currentStatus] ?? 0
                    } of ${searchCounts[currentStatus] ?? 0}`}
                  </Text>
                </Flex>
              </Item>
            )}
          </TabPanels>
        </Tabs>
      </Flex>

      <DialogContainer onDismiss={() => setCreateNewAccount(false)}>
        {createNewAccount && (
          <CreateParentSubDialog
            isPageLoading={isPageLoading}
            setPageLoading={setPageLoading}
            refreshTable={refreshTable}
            status={currentStatus}
          />
        )}
      </DialogContainer>

      <DialogContainer onDismiss={() => setViewAccountHistory(false)}>
        {viewAccountHistory && <SubHistoryDialog rowInfo={selectedRow} />}
      </DialogContainer>

      <DialogContainer onDismiss={() => setEditAccount(false)}>
        {editAccount && (
          <EditSubDialog
            rowInfo={selectedRow}
            status={currentStatus}
            isPageLoading={isPageLoading}
            setPageLoading={setPageLoading}
            refreshTable={refreshTable}
          />
        )}
      </DialogContainer>

      <DialogContainer onDismiss={() => setPromoteSub(false)}>
        {promoteSub && (
          <PromoteSubDialog
            rowInfo={selectedRow}
            status={currentStatus}
            isPageLoading={isPageLoading}
            setPageLoading={setPageLoading}
            refreshTable={refreshTable}
          />
        )}
      </DialogContainer>

      <DialogContainer onDismiss={() => setDemoteParent(false)}>
        {demoteParent && (
          <DemoteParentDialog
            rowInfo={selectedRow}
            status={currentStatus}
            isPageLoading={isPageLoading}
            setPageLoading={setPageLoading}
            refreshTable={refreshTable}
          />
        )}
      </DialogContainer>

      <DialogContainer onDismiss={() => setApproveSub(false)}>
        {approveSub && (
          <ApproveSubDialog
            rowInfo={selectedRow}
            isPageLoading={isPageLoading}
            setPageLoading={setPageLoading}
            refreshTable={refreshTable}
          />
        )}
      </DialogContainer>

      <DialogContainer onDismiss={() => setRejectSub(false)}>
        {rejectSub && (
          <RejectSubDialog
            rowInfo={selectedRow}
            isPageLoading={isPageLoading}
            setPageLoading={setPageLoading}
            refreshTable={refreshTable}
          />
        )}
      </DialogContainer>

      <DialogContainer onDismiss={() => setApproveRejectedSub(false)}>
        {approveRejectedSub && (
          <ApproveRejectedSubDialog
            rowInfo={selectedRow}
            isPageLoading={isPageLoading}
            setPageLoading={setPageLoading}
            refreshTable={refreshTable}
          />
        )}
      </DialogContainer>

      <DialogContainer onDismiss={() => setRevertPendingDeletionSub(false)}>
        {revertPendingDeletionSub && (
          <RevertPendingDeleteSubDialog
            rowInfo={selectedRow}
            isPageLoading={isPageLoading}
            setPageLoading={setPageLoading}
            refreshTable={refreshTable}
          />
        )}
      </DialogContainer>

      <DialogContainer onDismiss={() => setDownloadData(false)}>
        {downloadData && (
          <DownloadParentSubsDialog
            downloadRequest={fetchParentSubsRequest}
            setPageLoading={setPageLoading}
            isPageLoading={isPageLoading}
          />
        )}
      </DialogContainer>

      <DialogContainer onDismiss={() => setDeleteAccount(false)}>
        {deleteAccount && (
          <DeleteAccountDialog
            rowInfo={selectedRow}
            isPageLoading={isPageLoading}
            setPageLoading={setPageLoading}
            refreshTable={refreshTable}
          />
        )}
      </DialogContainer>

      {isSidePaneOpen && (
        <CamSlidingPane
          isPaneOpenFlag={isSidePaneOpen}
          handleOpenDialog={() => setIsSidePaneOpen(false)}
          paneTitle="Extended Attributes"
          Component={
            <ViewEnrichedAttributesForm
              data={sidePaneData}
              labels={GTMHInfoColumns()}
            />
          }
        />
      )}
    </Flex>
  );
}
